import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const SliderService = () => {
  const [t] = useTranslation("global");

  const [itemProducts, setItemProducts] = useState([]);

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 680,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  useEffect(() => {
    const detailsProducts = [
      {
        id: 1,
        nameProduct: "Red Voucher",
        subName: t("products.subname_rvo"),
        status: false,
        abrev: "rvo",
        descriptionProduct: t("products.descrip_rvo"),
        urlSite: "https://redvoucher.com/",
        logoProduct: "assets/imgs/logos/logo_rv.png",
      },
      {
        id: 2,
        nameProduct: "Kuimby",
        subName: t("products.subname_kuimby"),
        status: true,
        abrev: "kuimby",
        descriptionProduct: t("products.descrip_kuimby"),
        urlSite: "https://kuimby.com/",
        logoProduct: "assets/imgs/logos/logo_kuimby.png",
      },
      // {
      //   id: 3,
      //   nameProduct: "Red Pay",
      //   subName: t("products.subname_rpay"),
      //   status: false,
      //   descriptionProduct: t("products.descrip_rpay"),
      //   abrev: "rpay",
      //   urlSite: "https://www.redpay.mx/",
      //   logoProduct: "assets/imgs/logos/logo_rpay.png",
      // },
      {
        id: 4,
        nameProduct: "Red Access",
        subName: t("products.subname_ra"),
        status: true,
        descriptionProduct: t("products.descrip_ra"),
        abrev: "ra",
        urlSite: "https://sistema.redaccess.com/",
        logoProduct: "assets/imgs/logos/logo_ra.png",
      },
      // {
      //   id: 5,
      //   nameProduct: "Red Access Online",
      // 	subName:t("products.subname_rao"),
      //   status: false,
      //   abrev: "rao",
      //   descriptionProduct: t("products.descrip_rao"),
      //   urlSite: "https://www.redaccessonline.com/",
      //   logoProduct: "assets/imgs/logos/logo_rao.png",
      // },
      // {
      //   id: 6,
      // 	subName:t("products.subname_rpmkp"),
      //   status: false,
      //   nameProduct: "Red Pay Marketplace",
      //   abrev: "rpmkp",
      //   descriptionProduct: t("products.descrip_rpmkt"),
      //   urlSite: "https://redpay.mx/marketplace/",
      //   logoProduct: "assets/imgs/logos/logo_rpmkp.png",
      // },
      {
        id: 7,
        nameProduct: "Red Bear",
        subName: t("products.subname_rbear"),
        status: true,
        abrev: "rbear",
        descriptionProduct: t("products.descrip_rbear"),
        urlSite: "https://www.redbear.mx/",
        logoProduct: "assets/imgs/logos/logo_rbear.png",
      },
    ];
    setItemProducts(detailsProducts);
  }, [t]);

  return (
    <section className="wrapper_slider_service">
      <div className="container">
        <div className="box_ttls_sec">
          <h4 className="mb-0 ttls ttls_sections first">
            <span className="bg_span yellow text-light">
              {t("home.solutions_title_small")}
            </span>
          </h4>
          <h3 className="ttls ttls_sections mmenos">
            {t("home.solutions_title_1")}{" "}
            <span className="c_green">{t("home.solutions_title_2")}</span>
          </h3>

          <p className="paragraphs box_p ">{t("products.info_product")}</p>
        </div>
      </div>
      <div className="container_slider">
        <Slider {...settings}>
          {itemProducts.map((itemProduct) => (
            <div className={`box_item_solutions`} key={itemProduct.id}>
              <h1 className="number_product">0{itemProduct.id}</h1>
              <div className="item_solutions">
                <h1 className="ttls ">{itemProduct.nameProduct}</h1>
                <div className="subname">{itemProduct.subName}</div>
                <p className="p_paragraph">{itemProduct.descriptionProduct}</p>

                {itemProduct.nameProduct === "Red Voucher" ? (
                  <div>
                    <br />
                  </div>
                ) : (
                  <div>
                    <a
                      className="btns btn_compress "
                      target="_blank"
                      rel="noopener noreferrer"
                      href={itemProduct.urlSite}
                    >
                      <span>{t("products.more2")}</span>
                    </a>
                  </div>
                )}
                {/* */}
              </div>
              <div className={`box_picture ${itemProduct.abrev}`}>
                <img
                  className="logo_solution"
                  src={itemProduct.logoProduct}
                  alt="Somos Red Companies"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};
